export const removePolicyVersion = (policyNumber: string): string => {
  return policyNumber.split("-")[0];
};
